import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import Searchbox from "../../Misc/Searchbox";
import ReportListItem from "./ReportListItem";
import ReportSortings from "./ReportSortings";

export default class ReportList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      search: [],
      filters: {
        show: false,
        active: [],
        default: [],
        all: [],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: [],
    };
  }

  componentDidMount() {
    this.setDefaultFilters();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.nodeId !== this.props.nodeId ||
      prevProps.mode !== this.props.mode
    ) {
      this.setDefaultFilters();
    }
  }

  setDefaultFilters = async () => {
    let tree = this.context.api.nullUuid;
    if (this.props.nodeId && this.props.nodeId !== "any") {
      tree = this.props.nodeId;
    }

    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];

      filters.default.push({
        field: "tree",
        compare: "EQL",
        value: tree,
      });

      filters.default.push({
        field: "binding",
        compare: "ISN",
      });

      return filters;
    });
  };

  handleSortings = (sortings) => {
    this.setState({ sortings });
  };

  onSearch = (searchValue) => {
    let search = searchValue
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${searchValue}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({
      search,
    });
  };

  render() {
    return (
      <>
        <div className="d-flex mb-4">
          <div className="text-nowrap flex-grow-1 mr-2">
            <Searchbox onSearch={this.onSearch} />
          </div>
          <ReportSortings handleSortings={this.handleSortings} />
        </div>
        <List
          listKey="reportList"
          key={this.props.customListKey}
          fulltext={JSON.stringify(this.state.search)}
          search={JSON.stringify(
            this.state.filters.active.concat(this.state.filters.default)
          )}
          sort={JSON.stringify(this.state.sortings)}
          fields={JSON.stringify(this.state.fields.active)}
          limit={150}
          hideSinglePageNav={true}
          keyField="id"
          path="/report/list"
          blocker={{ spinnerFixed: true, hAuto: true }}
        >
          <ReportListItem
            highlightItem={this.props.itemId}
            nodeId={this.props.nodeId}
            mode={this.props.mode}
            itemMode={this.props.itemMode}
          />
        </List>
      </>
    );
  }
}
